import type { Dictionary } from "../dictionary";

const ru: Dictionary = {
  meta: {
    siteName: "Tetri Software",
    defaultTitle: "Tetri Copilot LLC — интеллектуальное программное обеспечение для бизнеса",
    defaultDescription:
      "Tetri Copilot LLC создаёт семейство интеллектуальных бизнес-продуктов Tetri — Tetri Copilot и Tetri Engage — и оказывает избранные услуги по разработке ПО, ИИ и веб-решений.",
  },

  nav: {
    home: "Главная",
    products: "Продукты",
    services: "Услуги",
    company: "Компания",
    contact: "Контакты",
    productsMenu: {
      copilot: "Tetri Copilot",
      copilotHint: "Финансы и операции без лишней сложности",
      engage: "Tetri Engage",
      engageHint: "Возможности под приоритетом",
      viewAll: "Все продукты",
    },
    cta: "Смотреть продукты",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    languageLabel: "Язык",
    skipToContent: "Перейти к содержимому",
  },

  footer: {
    tagline:
      "Tetri Copilot LLC создаёт интеллектуальное программное обеспечение, которое помогает бизнесу работать, взаимодействовать с клиентами и расти без лишней сложности.",
    productsHeading: "Продукты",
    servicesHeading: "Услуги",
    companyHeading: "Компания",
    legalHeading: "Правовая информация",
    company: {
      about: "О нас",
      services: "Услуги",
      contact: "Контакты",
      partnerships: "Партнёрство",
    },
    legal: {
      privacy: "Политика конфиденциальности",
      terms: "Условия использования",
      cookies: "Политика cookie",
    },
    rights: "Все права защищены.",
    registeredNote: "Tetri Copilot LLC зарегистрирована в Грузии.",
  },

  productPanel: {
    copilotTitle: "Обзор рабочего пространства",
    engageTitle: "Обзор воронки",
    copilotRows: [
      { label: "Счёт · Клиент А", status: "Отправлен" },
      { label: "Счёт · Клиент Б", status: "Оплачен" },
      { label: "Расход · Поездка", status: "Внесён" },
    ],
    engageRows: [
      { label: "Возможность · Сигнал А", status: "Новая" },
      { label: "Возможность · Сигнал Б", status: "Квалифицирована" },
      { label: "Контакт · Сигнал В", status: "Сегодня" },
    ],
    copilotScreenshotAlt:
      "Панель Tetri Copilot с выручкой, неоплаченными счетами, чистым денежным потоком и графиком движения средств",
    engageScreenshotAlt:
      "Воронка возможностей Tetri Engage с оценкой лидов ИИ и автоматически созданной задачей на follow-up",
  },

  common: {
    buttons: {
      exploreProducts: "Смотреть продукты",
      contactUs: "Связаться с нами",
      talkToUs: "Поговорить с нами",
      learnMore: "Узнать больше",
      visitProduct: "Перейти к продукту",
      discussProject: "Обсудить проект",
      sendMessage: "Отправить сообщение",
      viewAllProducts: "Все продукты",
      backHome: "На главную",
      viewServices: "Смотреть услуги",
      readMore: "Читать далее",
    },
    badges: {
      live: "Доступен",
      beta: "Бета",
      comingSoon: "Скоро",
    },
    labels: {
      capabilities: "Возможности",
      builtFor: "Создано для",
      relatedProducts: "Похожие продукты",
    },
  },

  seo: {
    home: {
      title: "Tetri Software — интеллектуальное ПО для малого и среднего бизнеса",
      description: "Бизнес-ПО с ИИ для растущих компаний в Грузии, ОАЭ, Саудовской Аравии, США и по всему миру: Tetri Copilot и Tetri Engage.",
    },
    products: {
      title: "Бизнес-ПО: Tetri Copilot и Tetri Engage | Tetri Software",
      description: "Сравните Tetri Copilot для счетов, расходов и соответствия требованиям и Tetri Engage для поиска лидов и последующих контактов. Для МСБ и растущих команд.",
    },
    copilot: {
      title: "Tetri Copilot: счета и учёт для малого бизнеса | Tetri Software",
      description: "Счета, расходы, бизнес-записи, контроль соответствия и отчётность в одном рабочем пространстве с ИИ для малого бизнеса в Грузии, ОАЭ, Саудовской Аравии и США.",
    },
    engage: {
      title: "Tetri Engage: поиск лидов и follow-up с ИИ | Tetri Software",
      description: "Находите перспективные возможности, ранжируйте лидов с помощью ИИ и держите каждый контакт под контролем. Для отделов продаж в Грузии, ОАЭ, KSA, США и не только.",
    },
    services: {
      title: "Разработка ПО, ИИ и сайтов | Tetri Software",
      description: "Разработка SaaS, автоматизация с ИИ, веб-приложения и сайты от команды Tetri Copilot и Tetri Engage — для клиентов в Грузии, ОАЭ, Саудовской Аравии и США.",
    },
    about: {
      title: "О компании Tetri Copilot LLC | Tetri Software",
      description: "Tetri Copilot LLC — софтверная компания, зарегистрированная в Грузии. Создаём семейство продуктов Tetri для бизнеса в ОАЭ, Саудовской Аравии, США и по всему миру.",
    },
    contact: {
      title: "Связаться с Tetri | Tetri Software",
      description: "Вопросы о Tetri Copilot, Tetri Engage, партнёрстве или проекте? Свяжитесь с командой Tetri по почте, телефону или через форму.",
    },
  },

  home: {
    hero: {
      heading: "Программное обеспечение, которое упрощает бизнес.",
      subheading:
        "Tetri создаёт сфокусированные бизнес-продукты. Tetri Copilot ведёт финансы и администрирование, Tetri Engage находит возможности и доводит контакты до результата, а команда, стоящая за ними, берёт избранные клиентские проекты.",
      ctaPrimary: "Смотреть продукты",
      ctaSecondary: "Поговорить с нами",
    },
    stage: {
      copilot: {
        description: "Счета, расходы, записи, контроль соответствия и отчётность в одном рабочем пространстве.",
        cta: "Смотреть Tetri Copilot",
      },
      engage: {
        description: "Поиск лидов, оценка возможностей и последующие контакты, которые не теряются.",
        cta: "Смотреть Tetri Engage",
      },
    },
    work: {
      heading: "Бизнес порождает больше работы, чем любая команда способна успевать выполнять.",
      body: "Каждый продукт Tetri берёт на себя часть этой работы и превращает её в сфокусированный интеллектуальный процесс, чтобы команда тратила меньше времени на управление системами.",
      listLabel: "Куда уходит работа",
      items: [
        { problem: "Записи, счета и задачи по соответствию разбросаны по разным инструментам", product: "copilot" },
        { problem: "Отчёты каждый месяц собираются вручную", product: "copilot" },
        { problem: "Перспективные возможности теряются в потоке информации", product: "engage" },
        { problem: "Последующие контакты незаметно теряются", product: "engage" },
      ],
    },
    copilot: {
      heading: "Администрирование бизнеса, которое не отвлекает от дела.",
      body: "Единое современное рабочее пространство для административной стороны бизнеса, где рутину берёт на себя ИИ.",
      capabilities: ["Счета", "Расходы", "Бизнес-записи", "Контроль соответствия", "Отчётность", "ИИ-помощь"],
      cta: "Смотреть Tetri Copilot",
    },
    engage: {
      heading: "От сигнала до контакта — с меньшим объёмом ручной работы.",
      body: "Tetri Engage помогает растущим командам находить перспективные возможности, выбирать самые важные и держать каждый последующий контакт под контролем.",
      steps: [
        { title: "Появляется сигнал", description: "Engage замечает активность, заслуживающую внимания." },
        { title: "Возможность оценивается", description: "ИИ ранжирует её, чтобы команда начинала с самых сильных лидов." },
        { title: "Создаётся задача на контакт", description: "Следующий шаг попадает в список нужного человека." },
      ],
      cta: "Смотреть Tetri Engage",
    },
    ai: {
      heading: "ИИ должен снимать нагрузку, а не создавать ещё одну систему для управления.",
      body: "Оба продукта следуют одному подходу: ИИ выполняет конкретную задачу внутри процесса, который у вас уже есть.",
      points: [
        { title: "Помощь", description: "Предлагает следующие шаги по вашим записям и готовит рутинные части, так что задачи начинаются наполовину выполненными." },
        { title: "Классификация", description: "Сортирует и размечает записи и возможности, чтобы они попадали на своё место без ручной работы." },
        { title: "Приоритизация", description: "Выделяет то, что требует внимания в первую очередь — от срочной задачи по соответствию до самого сильного лида." },
      ],
    },
    services: {
      heading: "Тот же продуктовый подход — в вашем проекте.",
      body: "Команда, которая создаёт Tetri Copilot и Tetri Engage, берёт небольшое число клиентских проектов с теми же инженерными стандартами.",
      cta: "Обсудить проект",
      items: [
        { title: "Заказное ПО и SaaS", description: "Порталы, внутренние системы, дашборды и SaaS-продукты, созданные с нуля." },
        { title: "ИИ и автоматизация", description: "ИИ-функции в вашем существующем ПО и автоматизация повторяющихся процессов." },
        { title: "Сайты и дизайн-системы", description: "Маркетинговые сайты на собственном коде и переиспользуемые дизайн-системы — быстрые и готовые к SEO." },
        { title: "Интеграции и консалтинг", description: "Интеграции API и платежей, облачная архитектура и техническая модернизация." },
      ],
      processLabel: "Как идёт проект",
      process: [
        { title: "Исследование", description: "Определяем задачу и результат." },
        { title: "Дизайн", description: "Формируем продукт до кода." },
        { title: "Разработка", description: "Выпускаем проверенными этапами." },
        { title: "Поддержка", description: "Эксплуатируем, измеряем, улучшаем." },
      ],
    },
    company: {
      heading: "Продуктовая компания, созданная для бизнеса по всему миру.",
      facts: [
        { value: "2", label: "Продукта на рынке" },
        { value: "4", label: "Языка: английский, арабский, грузинский, русский" },
        { value: "Весь мир", label: "Приоритетные рынки: Грузия, ОАЭ, Саудовская Аравия и США" },
        { value: "Грузия", label: "Tetri Copilot LLC, зарегистрирована в Грузии" },
      ],
      trust: [
        { title: "Защищённое облачное ПО.", description: "Построено на современной, поддерживаемой облачной инфраструктуре." },
        { title: "Дизайн с уважением к приватности.", description: "Каждый продукт собирает только то, что ему действительно нужно." },
        { title: "Прозрачные подписки.", description: "Понятные цены без скрытых условий." },
      ],
    },
    finalCta: {
      heading: "Найдите продукт Tetri, который подходит для следующего этапа роста.",
      body: "Ознакомьтесь с Tetri Copilot и Tetri Engage или расскажите нам, что нужно вашему бизнесу дальше.",
      ctaPrimary: "Смотреть продукты",
      ctaSecondary: "Связаться с Tetri",
    },
  },

  about: {
    hero: {
      eyebrow: "Компания",
      heading: "Компания, стоящая за семейством продуктов Tetri.",
      subheading:
        "Tetri Copilot LLC проектирует, разрабатывает и развивает интеллектуальное бизнес-ПО — а также оказывает избранные услуги по разработке для небольшого числа заказчиков.",
    },
    statement: {
      heading: "Чем мы занимаемся",
      body: [
        "Tetri Copilot LLC — продуктовая software-компания. Мы создаём, владеем и развиваем семейство бизнес-приложений Tetri, начиная с Tetri Copilot и Tetri Engage.",
        "Мы также работаем с избранными заказчиками над проектами в области ПО, ИИ и веб-разработки, применяя ту же продуктовую дисциплину, что и в собственных продуктах.",
      ],
    },
    builds: {
      heading: "Что создаёт Tetri",
      body: "Каждый продукт Tetri сфокусирован на конкретной области бизнес-операций, но построен на общем подходе к простоте, интеллектуальной автоматизации и современному дизайну ПО.",
      points: [
        { title: "Tetri Copilot", description: "ИИ-администрирование бизнеса, финансовые операции и соответствие требованиям для МСБ." },
        { title: "Tetri Engage", description: "ИИ-поиск возможностей, приоритизация и сопровождение контактов для растущих команд." },
      ],
    },
    vision: {
      heading: "Почему появилась Tetri",
      body: "Растущий бизнес накапливает операционную работу быстрее, чем успевает нанимать людей под неё: записи разбросаны, контакты теряются, а автоматизация часто добавляет сложности вместо того, чтобы её снимать. Tetri существует, чтобы превратить эту разрозненную работу в сфокусированное интеллектуальное ПО, с которым способна справиться небольшая команда.",
    },
    principles: {
      eyebrow: "Как мы работаем",
      heading: "Принципы, лежащие в основе каждого продукта Tetri.",
      items: [
        { title: "Практичный интеллект", description: "ИИ должен снимать нагрузку, а не создавать новые системы для управления." },
        { title: "Простота", description: "Сложные операционные задачи должны превращаться в понятное программное обеспечение." },
        { title: "Полезная автоматизация", description: "Автоматизация должна убирать рутину там, где она создаёт реальную ценность." },
        { title: "Качество", description: "Дизайн, инженерия, производительность и надёжность важны в каждом релизе." },
        { title: "Доверие", description: "Бизнес-ПО должно быть надёжным, безопасным и прозрачным." },
        { title: "Постоянное развитие", description: "Продукты развиваются исходя из реальных потребностей клиентов, а не догадок." },
      ],
    },
    international: {
      heading: "Где мы работаем",
      body: "Tetri создаётся как международное семейство продуктов с фокусом на этих рынках.",
      markets: [
        { code: "GE", name: "Грузия", note: "Домашний рынок и операционная база" },
        { code: "AE", name: "Объединённые Арабские Эмираты", note: "Приоритетный рынок роста" },
        { code: "SA", name: "Саудовская Аравия", note: "Приоритетный рынок роста" },
        { code: "US", name: "США", note: "Приоритетный рынок роста" },
        { code: "GCC", name: "Страны ССАГПЗ", note: "Расширяющийся региональный фокус" },
        { code: "Global", name: "Весь мир", note: "Доступно бизнесу в любой стране" },
      ],
    },
    technology: {
      heading: "Как мы создаём продукты",
      body: "Каждый продукт Tetri построен на современных, поддерживаемых технологиях — так, чтобы оставаться надёжным по мере роста семейства продуктов.",
      points: [
        "Современные веб-приложения",
        "Облачная, масштабируемая архитектура",
        "Интеграции через API",
        "ИИ применяется там, где создаёт измеримую ценность",
        "Безопасность и приватность учитываются с самого начала",
      ],
    },
    legal: {
      heading: "Юридическая информация",
      body: "Tetri Copilot LLC — юридическое лицо, стоящее за семейством продуктов Tetri и услугами, описанными на этом сайте.",
      entityLabel: "Юридическое лицо",
      entityValue: "Tetri Copilot LLC",
      jurisdictionLabel: "Зарегистрирована в",
      jurisdictionValue: "Грузии",
      contactLabel: "Деловые запросы",
    },
    cta: {
      heading: "Хотите узнать больше о Tetri?",
      body: "Ознакомьтесь с тем, что мы создаём, или свяжитесь с нами напрямую.",
      ctaPrimary: "Смотреть продукты",
      ctaSecondary: "Связаться с нами",
    },
  },

  products: {
    compare: {
      heading: "Какой продукт Tetri вам подходит?",
      focusLabel: "Основная задача",
      audienceLabel: "Для кого",
      outcomeLabel: "Что меняется",
      capabilitiesLabel: "Возможности",
    },
    hero: {
      eyebrow: "Продукты",
      heading: "Семейство продуктов Tetri.",
      subheading:
        "Два сфокусированных продукта, созданных и развиваемых Tetri Copilot LLC, объединённых общим подходом к простоте, интеллектуальной автоматизации и современному дизайну ПО.",
    },
    list: [
      {
        name: "Tetri Copilot",
        tagline: "Финансы и операции без лишней сложности",
        outcome: "Меньше времени на бумажную работу, больше — на бизнес.",
        description:
          "ИИ-администрирование бизнеса для МСБ — счета, расходы, записи, контроль соответствия требованиям и отчётность в едином современном рабочем пространстве.",
        capabilities: ["Счета", "Расходы", "Бизнес-записи", "Контроль соответствия", "Отчётность", "ИИ-помощь"],
        audience: "Владельцы МСБ, финансовые и операционные команды",
        ctaLabel: "Смотреть Tetri Copilot",
      },
      {
        name: "Tetri Engage",
        tagline: "Возможности под приоритетом",
        outcome: "Меньше упущенных возможностей из-за переполненного инбокса.",
        description:
          "ИИ-поиск возможностей и вовлечение клиентов для растущих команд — находите возможности, расставляйте приоритеты и держите контакты в порядке.",
        capabilities: ["Поиск возможностей", "Сигналы", "Приоритизация", "Последующие контакты", "Процессы вовлечения", "ИИ-помощь"],
        audience: "Отделы продаж и работы с клиентами",
        ctaLabel: "Смотреть Tetri Engage",
      },
    ],
    philosophy: {
      heading: "Одно семейство, одна философия",
      body: "Каждый продукт Tetri сфокусирован на конкретной области бизнес-операций, но следует общему подходу к простоте, интеллектуальной автоматизации и современному дизайну ПО — поэтому опыт использования остаётся единообразным, каким бы продуктом вы ни пользовались.",
    },
    future: {
      heading: "Создано для роста",
      body: "Архитектура продуктов Tetri рассчитана на появление новых продуктов по мере их анонса — без переработки того, как семейство работает вместе.",
    },
    cta: {
      heading: "Хотите увидеть продукт Tetri вблизи?",
      body: "Посетите сайт нужного продукта для подробностей или свяжитесь с нами, если остались вопросы.",
      ctaLabel: "Связаться с Tetri",
    },
  },

  copilotPage: {
    eyebrow: "Tetri Copilot",
    heading: "Администрирование бизнеса, которое не отвлекает от дела.",
    intro:
      "Tetri Copilot помогает малому и растущему бизнесу организовать счета, расходы, записи, задачи по соответствию требованиям, отчётность и повседневное администрирование в едином современном рабочем пространстве.",
    problemHeading: "Проблема",
    problemBody:
      "Администрирование бизнеса склонно распадаться на таблицы, почту и разрозненные инструменты — счета остаются без контроля, расходы фиксируются с опозданием, а сроки по соответствию требованиям обнаруживаются в последний момент. Tetri Copilot объединяет всё это в одном месте.",
    capabilitiesHeading: "Что умеет Tetri Copilot",
    capabilities: [
      { title: "Счета", description: "Создавайте, отправляйте и отслеживайте счета, не покидая рабочее пространство." },
      { title: "Расходы", description: "Фиксируйте и упорядочивайте расходы бизнеса по мере их появления." },
      { title: "Бизнес-записи", description: "Держите ключевую информацию о бизнесе организованной и легко доступной." },
      { title: "Контроль соответствия", description: "Отслеживайте повторяющиеся задачи и сроки по соответствию требованиям." },
      { title: "Отчётность", description: "Превращайте повседневные записи в понятные, полезные отчёты." },
      { title: "ИИ-помощь", description: "ИИ помогает находить, классифицировать и составлять черновики — снижая ручную нагрузку." },
    ],
    outcomesHeading: "Что меняется",
    outcomes: [
      "Записи бизнеса живут в едином организованном пространстве вместо разрозненных инструментов",
      "Выставление счетов и учёт расходов занимают минуты, а не часы",
      "Сроки по соответствию требованиям видны заранее, а не становятся срочными",
      "Отчётность отражает актуальную, реальную информацию",
    ],
    aiHeading: "Роль ИИ",
    aiBody:
      "Tetri Copilot использует ИИ для помощи в повседневном администрировании — поиске записей, классификации расходов и составлении типовых документов, — чтобы команда меньше времени тратила на ручной ввод данных.",
    audienceHeading: "Для кого это",
    audiences: ["Владельцы и руководители МСБ", "Финансовые и операционные команды", "Растущий бизнес, отказывающийся от таблиц"],
    scopeNote:
      "Tetri Copilot организует бизнес-записи, выставление счетов и контроль соответствия требованиям. Продукт не удерживает и не обрабатывает средства клиентов, не выступает банком или платёжным учреждением и не предоставляет кредитование или инвестиционные консультации.",
    ctaHeading: "Узнайте о Tetri Copilot подробнее",
    ctaBody: "Эта страница даёт общий обзор. Посетите официальный сайт Tetri Copilot, чтобы увидеть продукт полностью.",
    ctaLabel: "Перейти к Tetri Copilot",
    relatedHeading: "Похожие продукты",
  },

  engagePage: {
    flowHeading: "Как работает Tetri Engage",
    eyebrow: "Tetri Engage",
    heading: "От сигнала до контакта — с меньшим объёмом ручной работы.",
    intro:
      "Tetri Engage помогает растущим командам находить перспективные возможности, расставлять приоритеты, организовывать последующие контакты и снижать объём повторяющейся работы по взаимодействию с клиентами.",
    problemHeading: "Проблема",
    problemBody:
      "Перспективные возможности теряются в потоке переполненного инбокса, а ручное сопровождение контактов плохо масштабируется по мере роста команды. Tetri Engage превращает разрозненные сигналы в организованную, приоритизированную воронку.",
    capabilitiesHeading: "Что умеет Tetri Engage",
    capabilities: [
      { title: "Поиск возможностей", description: "Находите перспективные возможности до того, как они потеряются." },
      { title: "Сигналы", description: "Превращайте релевантную активность в конкретные сигналы к действию." },
      { title: "Приоритизация возможностей", description: "Видите, что заслуживает внимания в первую очередь." },
      { title: "Последующие контакты", description: "Держите каждый следующий контакт организованным и по графику." },
      { title: "Процессы вовлечения", description: "Структурируйте работу без ручной рутины." },
      { title: "ИИ-помощь", description: "ИИ помогает квалифицировать, приоритизировать и готовить черновики обращений." },
    ],
    outcomesHeading: "Что меняется",
    outcomes: [
      "Возможности находятся и упорядочиваются, а не теряются",
      "Команда знает, с чего начать в первую очередь",
      "Последующие контакты происходят по графику, а не по памяти",
      "Меньше повторяющейся ручной работы по взаимодействию",
    ],
    aiHeading: "Роль ИИ",
    aiBody:
      "Tetri Engage использует ИИ для помощи в квалификации возможностей, расстановке приоритетов и составлении черновиков сопровождения — при этом команда всегда контролирует, что именно отправляется.",
    audienceHeading: "Для кого это",
    audiences: ["Отделы продаж и работы с клиентами", "Растущие команды без выделенной операционной функции", "Команды, которые сегодня полагаются на ручное сопровождение"],
    scopeNote:
      "Tetri Engage поддерживает поиск возможностей и организованное сопровождение контактов. Продукт не гарантирует результаты продаж или качество лидов, не выполняет неограниченный сбор данных и не отправляет полностью автономные обращения без контроля со стороны команды.",
    ctaHeading: "Узнайте о Tetri Engage подробнее",
    ctaBody: "Эта страница даёт общий обзор. Посетите официальный сайт Tetri Engage, чтобы увидеть продукт полностью.",
    ctaLabel: "Перейти к Tetri Engage",
    relatedHeading: "Похожие продукты",
  },

  services: {
    hero: {
      eyebrow: "Услуги",
      heading: "Тот же продуктовый подход — в вашем проекте.",
      subheading:
        "Tetri Copilot LLC создаёт Tetri Copilot и Tetri Engage как собственные продукты — и применяет ту же инженерную дисциплину в работе с избранным числом заказчиков.",
    },
    categories: [
      {
        slug: "saas-development",
        title: "Разработка SaaS-продуктов",
        summary: "Полный цикл проектирования и разработки SaaS-приложений — от первого релиза до последующего развития.",
        outcomes: ["Готовый к работе SaaS-продукт", "Архитектура, рассчитанная на реальную нагрузку", "Поддерживаемая кодовая база, которую сможет развивать ваша команда"],
      },
      {
        slug: "ai-automation",
        title: "Внедрение ИИ и автоматизация",
        summary: "Практичные ИИ-функции и автоматизация процессов для новых или уже существующих продуктов.",
        outcomes: ["ИИ-помощь, встроенная в реальные рабочие процессы", "Автоматизация действительно рутинных задач", "Интеллектуальный поиск, классификация и приоритизация"],
      },
      {
        slug: "web-development",
        title: "Разработка веб-приложений",
        summary: "Порталы, панели управления и внутренние инструменты, спроектированные под реальные процессы вашего бизнеса.",
        outcomes: ["Инструмент, созданный под ваш процесс, а не по шаблону", "Аккуратная интеграция с существующими системами", "Интерфейс, которым команда действительно будет пользоваться"],
      },
      {
        slug: "business-automation",
        title: "Автоматизация бизнес-процессов",
        summary: "Устранение повторяющейся ручной работы в операционных процессах с помощью целевой автоматизации.",
        outcomes: ["Меньше повторяющихся ручных шагов", "Процессы, работающие стабильно", "Время, перенаправленное на более ценные задачи"],
      },
      {
        slug: "website-development",
        title: "Дизайн и разработка сайтов",
        summary: "Сайты для бизнеса и SaaS-продуктов с индивидуальной разработкой, ориентированные на доверие и конверсию.",
        outcomes: ["Быстрый, профессиональный, вызывающий доверие сайт", "Переиспользуемая дизайн-система для будущих страниц", "SEO-готовая структура с первого дня"],
      },
      {
        slug: "consulting-support",
        title: "Консультации и техническая поддержка",
        summary: "Техническое консультирование, аудит архитектуры и постоянная поддержка существующего ПО.",
        outcomes: ["Понятное, практичное техническое направление", "Архитектура, проверенная опытной продуктовой командой", "Постоянная поддержка, на которую можно рассчитывать"],
      },
    ],
    approach: {
      eyebrow: "Как мы работаем",
      heading: "Продуктовое мышление — в вашем проекте.",
      body: "Мы подходим к каждому проекту так же, как к собственным продуктам — начиная с результата, а не со списка функций.",
      steps: [
        { title: "Понимание", description: "Мы начинаем с понимания бизнес-задачи, а не только технического задания." },
        { title: "Проектирование и разработка", description: "Мы проектируем и разрабатываем по тем же стандартам, что и Tetri Copilot и Tetri Engage." },
        { title: "Поддержка", description: "Мы остаёмся на связи после запуска, чтобы ПО продолжало работать по мере изменений в бизнесе." },
      ],
    },
    proof: {
      heading: "Создано командой, стоящей за Tetri Copilot и Tetri Engage",
      body: "Наши возможности в области услуг основаны на опыте создания и развития собственных продуктов — те же инженерные стандарты применяются и в вашем проекте.",
    },
    faq: {
      heading: "Частые вопросы",
      items: [
        {
          question: "Tetri Copilot LLC берётся за любой проект?",
          answer: "Нет. Мы работаем с ограниченным числом заказчиков одновременно, чтобы каждый проект получал реальное внимание продуктовой команды.",
        },
        {
          question: "Это та же команда, что создаёт Tetri Copilot и Tetri Engage?",
          answer: "Да. Услуги оказывает та же команда с теми же инженерными стандартами, что и в собственных продуктах.",
        },
        {
          question: "Можно ли интегрировать услуги с Tetri Copilot или Tetri Engage?",
          answer: "Во многих случаях да — свяжитесь с нами, и мы обсудим, что подойдёт именно вам.",
        },
      ],
    },
    cta: {
      heading: "Есть идея проекта?",
      body: "Расскажите нам о ней, и мы скажем, подходит ли она нам.",
      ctaLabel: "Обсудить проект",
    },
  },

  contact: {
    hero: {
      eyebrow: "Контакты",
      heading: "Обсудим, что вам нужно.",
      subheading: "Вопросы о продуктах, идеи для партнёрства или проект, который хотите обсудить — будем рады услышать вас.",
    },
    reasons: [
      { title: "Вопросы о продуктах", description: "Вопросы о Tetri Copilot или Tetri Engage." },
      { title: "Партнёрство", description: "Реферальные, реселлерские или технологические партнёрства." },
      { title: "Услуги", description: "Проекты в области ПО, ИИ или веб-разработки." },
      { title: "Остальное", description: "СМИ, вопросы о компании или что-то ещё, не указанное выше." },
    ],
    info: {
      heading: "Прямой контакт",
      emailLabel: "Email",
      phoneLabel: "Телефон",
      phones: ["+995 55 000 4769", "+995 511 415 313"],
      locationLabel: "Расположены в",
      locationValue: "Грузия — работаем в Грузии, ОАЭ, Саудовской Аравии, США и по всему миру",
    },
    form: {
      heading: "Отправить сообщение",
      nameLabel: "Имя",
      namePlaceholder: "Ваше полное имя",
      emailLabel: "Рабочий email",
      emailPlaceholder: "you@company.com",
      companyLabel: "Компания",
      companyPlaceholder: "Название вашей компании",
      inquiryTypeLabel: "Тип запроса",
      inquiryTypePlaceholder: "Выберите тип запроса",
      inquiryTypes: [
        { value: "product", label: "Вопрос о продукте" },
        { value: "sales-demo", label: "Продажи / демонстрация" },
        { value: "partnership", label: "Партнёрство" },
        { value: "software-development", label: "Разработка ПО" },
        { value: "ai-automation", label: "ИИ / автоматизация" },
        { value: "website-development", label: "Разработка сайта" },
        { value: "media", label: "СМИ / о компании" },
        { value: "other", label: "Другое" },
      ],
      countryLabel: "Страна (необязательно)",
      countryPlaceholder: "Ваша страна",
      messageLabel: "Сообщение",
      messagePlaceholder: "Расскажите немного о том, что вам нужно.",
      privacyNotice: "Отправляя форму, вы соглашаетесь с нашей Политикой конфиденциальности. Мы используем ваши данные только для ответа на запрос.",
      submit: "Отправить сообщение",
      submitting: "Отправка…",
      successHeading: "Сообщение отправлено.",
      successBody: "Спасибо — мы получили ваше сообщение и скоро свяжемся с вами.",
      errorHeading: "Что-то пошло не так.",
      errorBody: "Сообщение не было отправлено. Попробуйте ещё раз или напишите нам напрямую.",
      retry: "Попробовать снова",
      devModeHeading: "Форма обратной связи ещё не подключена",
      devModeBody:
        "В этом окружении не настроен адрес для приёма формы, поэтому отправка недоступна. Укажите VITE_CONTACT_FORM_ENDPOINT (см. .env.example), чтобы включить её.",
      validation: {
        required: "Это поле обязательно для заполнения.",
        invalidEmail: "Введите корректный email-адрес.",
        tooShort: "Добавьте, пожалуйста, немного больше деталей.",
      },
    },
  },

  legal: {
    privacy: {
      title: "Политика конфиденциальности",
      updated: "Последнее обновление: сентябрь 2026",
      intro:
        "Эта политика объясняет, какую информацию Tetri Copilot LLC собирает через данный сайт и как она используется. Она относится только к корпоративному сайту tetricopilot.com; продукты Tetri Copilot и Tetri Engage могут иметь собственные уведомления о конфиденциальности.",
      sections: [
        {
          title: "Какую информацию мы собираем",
          description: "При отправке формы обратной связи мы собираем предоставленную вами информацию — имя, рабочий email, компанию и сообщение. Для просмотра сайта учётная запись не требуется.",
        },
        {
          title: "Как мы используем информацию",
          description: "Мы используем данные из формы обратной связи только для ответа на ваш запрос и ведения записи деловой переписки. Мы не продаём персональные данные третьим лицам.",
        },
        {
          title: "Cookie и аналитика",
          description: "Сайт может использовать необходимые для работы cookie-файлы и аналитику с уважением к приватности для понимания общей посещаемости. Подробности — в Политике cookie.",
        },
        {
          title: "Хранение данных",
          description: "Мы храним обращения из формы столько, сколько разумно необходимо для ответа и документирования деловой переписки.",
        },
        {
          title: "Ваши права",
          description: "Вы можете запросить доступ, исправление или удаление предоставленной нам информации, написав на info@tetricopilot.com.",
        },
        {
          title: "Контакты",
          description: "Вопросы об этой политике можно направлять на info@tetricopilot.com.",
        },
      ],
    },
    terms: {
      title: "Условия использования",
      updated: "Последнее обновление: сентябрь 2026",
      intro:
        "Эти условия регулируют использование корпоративного сайта Tetri Copilot LLC. Использование отдельных продуктов Tetri (Tetri Copilot, Tetri Engage) регулируется их собственными условиями, доступными на соответствующих сайтах.",
      sections: [
        {
          title: "Использование сайта",
          description: "Этот сайт предоставлен для представления Tetri Copilot LLC, семейства продуктов Tetri и наших услуг. Вы соглашаетесь использовать его только в законных целях.",
        },
        {
          title: "Интеллектуальная собственность",
          description: "Название Tetri, логотип и содержимое сайта являются собственностью Tetri Copilot LLC и не могут использоваться без разрешения.",
        },
        {
          title: "Отсутствие гарантий",
          description: "Этот сайт и его содержимое предоставляются «как есть», без каких-либо гарантий, в пределах, допустимых законом.",
        },
        {
          title: "Ограничение ответственности",
          description: "Tetri Copilot LLC не несёт ответственности за косвенные или последующие убытки, возникшие в связи с использованием сайта, в пределах, допустимых законом.",
        },
        {
          title: "Изменения условий",
          description: "Мы можем время от времени обновлять эти условия. Продолжение использования сайта означает согласие с действующими условиями.",
        },
        {
          title: "Контакты",
          description: "Вопросы об этих условиях можно направлять на info@tetricopilot.com.",
        },
      ],
    },
    cookies: {
      title: "Политика cookie",
      updated: "Последнее обновление: сентябрь 2026",
      intro: "Эта политика объясняет, как Tetri Copilot LLC использует cookie-файлы и аналогичные технологии на этом сайте.",
      sections: [
        {
          title: "Какие cookie мы используем",
          description: "Мы используем необходимые cookie-файлы для корректной работы сайта, а также можем использовать аналитические cookie с уважением к приватности для понимания общей посещаемости.",
        },
        {
          title: "Управление cookie",
          description: "Большинство браузеров позволяют управлять или отключать cookie-файлы в настройках. Отключение необходимых cookie может повлиять на работу некоторых частей сайта.",
        },
        {
          title: "Cookie третьих сторон",
          description: "Мы не допускаем рекламные cookie-файлы третьих сторон на этом сайте.",
        },
        {
          title: "Контакты",
          description: "Вопросы об этой политике можно направлять на info@tetricopilot.com.",
        },
      ],
    },
  },

  notFound: {
    eyebrow: "404",
    heading: "Такой страницы не существует.",
    body: "Страница, которую вы ищете, могла быть перемещена или никогда не существовала. Вот несколько полезных мест, куда можно перейти.",
    ctaHome: "Главная",
    ctaProducts: "Продукты",
    ctaContact: "Контакты",
  },
};

export default ru;
